var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('area-chart',{attrs:{"info-card":_vm.computedInfoCards,"data-series":_vm.computedSeries,"time-stamps":_vm.timeStamps,"format-percentage":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }